export default "__VITE_ASSET__a6ba4673__"